define('views/pages/schedule',['require','underscore','jquery','views/base/view','views/base/page','lib/utils','text!templates/pages/schedule/index.ejs','text!templates/pages/schedule/timer.ejs'],function(require) {
    'use strict';

    var _ = require('underscore'),
        $ = require('jquery'),
        View = require('views/base/view'),
        PageView = require('views/base/page'),
        utils = require('lib/utils'),
        templateIndex = require('text!templates/pages/schedule/index.ejs'),
        templateTimer = require('text!templates/pages/schedule/timer.ejs');

    // Schedule

    var ScheduleTimerView = View.extend({
        autoRender: false,
        template: templateTimer,
        className: 'schedule-timer',
        listen: {
            'change:timerLeft model': 'render'
        }
    });

    var SchedulePageView = PageView.extend({
        autoRender: true,
        template: templateIndex,
        id: 'pages-schedule-page',
        listen: {
            'change:loading model': 'updateLoading'
        },
        regions: {
            'timer': '.schedule-content-container'
        },
        contentSelector: '.schedule-content-container',
        rowTitlesSelector: '.schedule-rowtitles-container',
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);

            var mousewheelevt = (/Firefox/i.test(navigator.userAgent))? 'DOMMouseScroll' : 'mousewheel';

            this.delegate(mousewheelevt, this.contentSelector, this.onWheel);
            this.delegate('mousemove', this.contentSelector, this.mouseMove);

            this.subview('timer', new ScheduleTimerView({ region: 'timer', model: this.model }));

            this._onResize = _.bind(this.onResize, this);

            $(window).on('resize', this._onResize);
        },

        dispose: function() {
            if (!this.disposed) {
                $(window).off('resize', this._onResize);
            }
            PageView.prototype.dispose.apply(this, arguments);
        },

        onResize: function() {
            var $el = $('.schedule-day-content-tail');
            if ($el.length) {
                var height = $(window).height() - this.model.get('contentHeight');
                $el.css('height', height + 'px');
            }
        },

        checkScrollBounds: function(date) {
            if (!this.model.checkBounds(date)) {
                this.model.set('loadCenter', date);
                this.model.load();
            }
        },
        mouseMove: function() {

        },
        onScroll: function() {
            if (this.model.get('loading')) { return; }

            var scrollLeft = this.$elContent.scrollLeft();
            var prevScrollLeft = this.scrollLeft || scrollLeft;

            this.checkScrollBounds(this.model.positionToTime(scrollLeft, prevScrollLeft < scrollLeft));

            this.scrollLeft = scrollLeft;

            _.each(this.scheduleItemsReset, function(item) {
                if (!(item.left < scrollLeft && scrollLeft < item.right)) {
                    item.$title.stop();
                    item.$title.animate({ 'margin-left': '0px' }, 250);
                }
            });

            var resetItems =  [];
            this.scheduleItemsReset = resetItems;

            this.$scheduleItems.each(function(index, item) {
                if (item.left < scrollLeft && scrollLeft < item.right) {
                    var offset = Math.min(Math.max(scrollLeft - item.left - 14, 0), item.width - item.titleWidth - 24);

                    item.$title.stop();
                    item.$title.animate({ 'margin-left': offset + 'px' }, 250);

                    resetItems.push(item);
                }
            });
        },
        onWheel: function(e) {
            e.stopPropagation();
            e.preventDefault();
            e = e.originalEvent;
            var delta = e.detail ? e.detail * (-120) : e.wheelDelta;
            this.$elContent.scrollLeft(this.$elContent.scrollLeft() - delta);
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('timer').render();

            this.$elContent = this.$(this.contentSelector);
            this.$elRowTitlesSelector = this.$(this.rowTitlesSelector);

            this.scheduleItemsReset = [];
            this.$scheduleItems = this.$('.schedule-item').map(function(index, item) {
                var $item = $(item);
                var $title = $($item.find('.schedule-item-title span')[0]);
                var pos = $item.position();
                var width = $item.width();
                return {
                    left: pos.left,
                    right: pos.left + width,
                    width: width,

                    $item: $item,
                    $title: $title,

                    titleWidth: $title.width()
                };
            });

            this.$elContent.off('scroll').on('scroll', _.bind(this.onScroll, this));
            // this.$elContent.off('mousewheel').on('mousewheel', _.bind(this.onWheel, this));
        },
        updateLoading: function() {
            if (this.model.get('loading')) {
                this.render();
                this.$el.addClass('loading');
                this.$elContent.scrollLeft(this.model.timeToPosition(this.model.get('loadCenter')));
            } else {
                this.$el.removeClass('loading');
                this.render();

                this.$elContent.scrollLeft(this.model.timeToPosition(this.model.get('loadCenter')));

                if (!this.model.get('first')) {
                    this.model.set('first', true);
                } else {
                    utils.changeURL('schedule#show', { date: utils.fmtDate(this.model.get('loadCenter')) }, {}, { replace: true, trigger: false });
                }
            }
        }
    });

    return SchedulePageView;
});

